
// Definición de defaults

export const defaultMateria: MateriaProps = {
    idMateria:      0,
    descripcion:    '',
    activo:         false,
}

// Creación de interfaces

export interface MateriaProps{
    idMateria:      number;
    descripcion:    string;
    activo:         boolean;
}